import styled, { css, keyframes } from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

const fadeIn = keyframes`
  0% {
    background: rgba(0, 0, 0, .0);
  }
  100% {
    background: rgba(0, 0, 0, .7);
  }
`

const fadeOut = keyframes`
  0% {
    background: rgba(0, 0, 0, .7);
  }
  100% {
    background: rgba(0, 0, 0, .0);
  }
`

const scaleUp = keyframes`
  0% {
    transform: scale(.8) translateY(1000px);
    opacity: 0;
  }
  100% {
    transform: scale(1) translateY(0px);
    opacity: 1;
  }
`
const scaleDown = keyframes`
  0% {
    transform: scale(1) translateY(0px);
    opacity: 1;
  }
  100% {
    transform: scale(.8) translateY(1000px);
    opacity: 0;
  }
`
export const Modal = styled.div`
    @media only screen and (min-width: 960px) {
        min-width: 25rem;
    }
    max-width: 50vw;
    background: #fff;
    padding: 2rem;
    gap: 2rem;
    display: flex;
    flex-direction: column;
    //height: fit-content;
    border-radius: 3px;
    font-weight: 300;
    position: relative;
`

interface AbsoluteBlockProps {
    ZIndex?: number
    isOpened: boolean
}

export const HeaderTitle = styled.h1`
    font-size: 1.1rem;
`

export const ButtonClose = styled.button`
    box-shadow: none;
    outline: none;
    margin: 0;
    background-color: white;
    height: 100%;
    border: none;
    cursor: pointer;
    width: 2.6rem;

    & svg {
        fill: ${ThemeColors.gray40};
    }

    &:hover > svg {
        fill: ${ThemeColors.black};
    }
`

export const Header = styled.header`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const Body = styled.div``
export const Footer = styled.div`
    display: flex;
    font-size: 1rem;
    justify-content: flex-end;

    & > * {
        margin-left: 1rem;
    }
`
export const Container = styled.div<AbsoluteBlockProps>`
    position: fixed;
    display: ${({ isOpened = false }) => (isOpened ? 'inline-block' : 'none')};
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;

    z-index: ${({ ZIndex = 80 }) => ZIndex};
`
export const Background = styled.div<AbsoluteBlockProps>`
    /*  height: 100%;
width: 100%;
position: fixed;
left: 0;
top: 0;
display: flex;
justify-content: center;
align-items: center;
box-sizing: border-box;
@media only screen and (max-width: 960px) {
  padding: 1rem;
}*/

    /*${Modal} {
        box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
    }*/

    /*display: table-cell;
    background: rgba(0, 0, 0, 0.8);
    text-align: center;
    vertical-align: middle;
    transform: scale(0);
    overflow: hidden;*/

    display: flex;
    background: rgba(0, 0, 0, 0.8);
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    transform: scale(1);

    ${(props) =>
        props.isOpened
            ? css`
                  transform: scale(1);
                  background: rgba(0, 0, 0, 0);
                  animation: ${fadeIn} 0.3s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;

                  ${Modal} {
                      opacity: 0;
                      animation: ${scaleUp} 0.3s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
                  }
              `
            : css`
                  transform: scale(0);
                  animation: ${fadeOut} 0.3s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;

                  ${Modal} {
                      animation: ${scaleDown} 0.3s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
                  }
              `}
`
